import React from 'react';
import ChipMUI, { ChipProps as ChipMUIProps } from '@mui/material/Chip';

export type ChipProps = ChipMUIProps;

export function Chip(props: ChipProps): JSX.Element {
  return <ChipMUI {...props} />;
}
